import React from 'react';
import { Text } from 'react-native';

//= ========================================================================

const Paragraph = ({
  children, marginBottom = 10, marginTop = 0,
}) => (
  <Text style={{
    fontSize: 16,
    color: '#556074',
    marginBottom,
    marginTop,
  }}
  >
    {children}
  </Text>
);
export default Paragraph;
